import { ColumnDescription } from 'react-bootstrap-table-next';
import { IManagerMillUser } from 'interfaces/Manager/user';
import i18n from 'translations';

interface IHideColumn {
  [key: string]: boolean;
}

export const getColumns = (
  hideColumns: IHideColumn
): ColumnDescription<any, IManagerMillUser>[] => {
  return [
    {
      dataField: 'id',
      text: 'Id',
      hidden: true,
    },
    {
      dataField: 'dealerCustomerId',
      text: i18n.t('customerManagement.customerId'),
      style: { width: '0%' },
      hidden: true,
    },
    {
      dataField: 'dealerInfo.dealerId',
      text: i18n.t('dealerManagement.dealerId'),
      style: { width: '25%' },
      hidden: !!hideColumns.dealerId,
      sort: true,
    },
    {
      dataField: 'customerInfo.company',
      text: i18n.t('customerManagement.company'),
      style: { width: '25%' },
      hidden: !!hideColumns.company,
      sort: true,
    },
    {
      dataField: 'customerInfo.firstName',
      text: i18n.t('customerManagement.firstName'),
      style: { width: '25%' },
      hidden: !!hideColumns.firstName,
      sort: true,
    },
    {
      dataField: 'customerInfo.lastName',
      text: i18n.t('customerManagement.lastName'),
      style: { width: '25%' },
      hidden: !!hideColumns.lastName,
      sort: true,
    },
  ];
};
